import { render, staticRenderFns } from "./MyProfileView.vue?vue&type=template&id=62fd2c51&scoped=true&"
import script from "./MyProfileView.vue?vue&type=script&lang=js&"
export * from "./MyProfileView.vue?vue&type=script&lang=js&"
import style0 from "./MyProfileView.vue?vue&type=style&index=0&id=62fd2c51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fd2c51",
  null
  
)

export default component.exports